import { render, staticRenderFns } from "./ServicesOverview.vue?vue&type=template&id=651d5cd0&scoped=true&lang=pug"
import script from "./ServicesOverview.vue?vue&type=script&lang=js"
export * from "./ServicesOverview.vue?vue&type=script&lang=js"
import style0 from "./ServicesOverview.vue?vue&type=style&index=0&id=651d5cd0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651d5cd0",
  null
  
)

export default component.exports